import React from 'react';
import PropTypes from 'prop-types';
import './CircularWait.css';

const CircularWait = ({ size = 'small', loading, children }) => {
  const sizeClass = size;

  loading = loading === undefined ? false : loading;
  if (!loading) {
    return <>{children}</>;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <div className={`circular-wait ${sizeClass}`} />
    </div>
  );
};

CircularWait.propTypes = {
  size: PropTypes.oneOf(['large', 'medium', 'small']).isRequired,
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node
};

export default CircularWait;